var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"system-msg-container"},[_c('span',{staticClass:"system-msg"},[_vm._v(_vm._s(_vm.getMessageByType))])])
}
var staticRenderFns = []

export { render, staticRenderFns }